(() => {
  const rootPath = () => (window.Shopify?.routes?.root || window.theme?.routes?.root || '/');
  const formatMoney = (cents, format = window.theme?.moneyFormat || '${{amount}}') => {
    const value = Number(cents || 0);
    const withDelimiter = (number, precision = 2, thousands = ',', decimal = '.') => {
      if (Number.isNaN(number) || number == null) return '0';
      const parts = (number / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      return parts.join(decimal);
    };
    const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
    const formatted = placeholder === 'amount_no_decimals' ? withDelimiter(value, 0) : withDelimiter(value, 2);
    return format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  };
  const showToast = (message) => {
    const toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => { toast.hidden = true; }, 2800);
  };
  const lockBody = (locked) => document.body.classList.toggle('drawer-open', locked);
  const openDrawer = (drawer) => { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); lockBody(true); };
  const closeDrawer = (drawer) => { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); lockBody(false); };

  window.ThemeUtils = { rootPath, formatMoney, showToast, openDrawer, closeDrawer };

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-quantity-minus]');
    const plus = event.target.closest('[data-quantity-plus]');
    if (minus || plus) {
      const selector = event.target.closest('.quantity-selector');
      const input = selector?.querySelector('input[type="number"]');
      if (!input) return;
      const step = Number(input.step || 1);
      const min = Number(input.min || 0);
      input.value = String(Math.max(min, Number(input.value || 0) + (plus ? step : -step)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.querySelectorAll('product-recommendations').forEach((element) => {
    if (!element.dataset.url) return;
    const observer = new IntersectionObserver((entries, obs) => {
      if (!entries[0].isIntersecting) return;
      obs.unobserve(element);
      fetch(element.dataset.url).then((response) => response.text()).then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const replacement = html.querySelector('product-recommendations');
        if (replacement?.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
      }).catch(() => {});
    }, { rootMargin: '300px' });
    observer.observe(element);
  });

  document.querySelectorAll('[data-countdown]').forEach((element) => {
    const end = new Date(element.dataset.endDate).getTime();
    if (Number.isNaN(end)) return;
    const update = () => {
      const distance = end - Date.now();
      if (distance <= 0) { element.hidden = true; clearInterval(timer); return; }
      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);
      element.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
      element.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      element.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      element.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
    };
    update();
    const timer = setInterval(update, 1000);
  });

  document.querySelectorAll('[data-before-after]').forEach((element) => {
    const input = element.querySelector('[data-before-after-range]');
    input?.addEventListener('input', () => element.style.setProperty('--position', `${input.value}%`));
  });

  document.querySelectorAll('[data-shipping-calculator]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const results = form.querySelector('[data-shipping-results]');
      const country = form.querySelector('[data-shipping-country]')?.value || '';
      const province = form.querySelector('[data-shipping-province]')?.value || '';
      const zip = form.querySelector('[data-shipping-zip]')?.value || '';
      results.textContent = 'Calculating…';
      const params = new URLSearchParams({
        'shipping_address[country]': country,
        'shipping_address[province]': province,
        'shipping_address[zip]': zip
      });
      try {
        const response = await fetch(`${rootPath()}cart/shipping_rates.json?${params.toString()}`);
        const data = await response.json();
        if (!response.ok) throw new Error(data?.zip?.[0] || data?.message || 'Unable to calculate rates.');
        if (!data.shipping_rates?.length) { results.textContent = 'No rates found for this address.'; return; }
        results.innerHTML = `<ul>${data.shipping_rates.map((rate) => `<li>${rate.name}: ${rate.price}</li>`).join('')}</ul>`;
      } catch (error) { results.textContent = error.message; }
    });
  });

  const cookieBanner = document.querySelector('[data-cookie-banner]');
  if (cookieBanner && !localStorage.getItem('maison-cookie-choice')) cookieBanner.hidden = false;
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cookie-accept]')) { localStorage.setItem('maison-cookie-choice', 'accepted'); cookieBanner.hidden = true; }
    if (event.target.closest('[data-cookie-decline]')) { localStorage.setItem('maison-cookie-choice', 'declined'); cookieBanner.hidden = true; }
  });

  const backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    const toggle = () => backToTop.classList.toggle('is-visible', scrollY > 650);
    toggle(); addEventListener('scroll', toggle, { passive: true });
    backToTop.addEventListener('click', () => scrollTo({ top: 0, behavior: 'smooth' }));
  }
})();
